<template>
  <div class="history">
      <div
      class="banner"
      v-if="!!startTime"
      :style="{
        backgroundImage: 'url(' + $setPicSize('7965b522-577f-4654-809e-9fbd6e513bb4.png') + ')',
      }"
    >
      <div class="word">
        <div class="status">生效中</div>
        <div class="time">
          <span>{{ startTime | formatTime }}</span>
          <span> - </span>
          <span>{{ endTime | formatTime }}</span>
        </div>
      </div>
    </div>

    <section class="receive" :class="compensationList.length === 0 && 'empty'">
      <div class="title"><b>领取记录</b></div>
      <div v-for="item in receiveList" :key="item" class="receive-card">
        <div class="time">
          <span>{{ item.startTime | formatTime }}</span>
          <span> - </span>
          <span>{{ item.endTime | formatTime }}</span>
        </div>
        <div class="status">
          <span>{{ item.statusMsg }}</span>
        </div>
      </div>
      <z-stance
        v-if="!loading && receiveList.length === 0"
        :show-btn="false"
        type="general"
        :show-info="false"
        descText="您暂时还没有领取欧~返回上一页点击领取吧"
      />
    </section>

    <section class="product" :class="compensationList.length === 0 && 'empty'">
      <div class="title"><b>赔付记录</b></div>
      <div v-for="item in compensationList" :key="item">
        <div class="product-card" @click="toDetial(item.orderId)">
          <div class="product-card-header">
            <div>
              <span><b>申请时间：</b></span
              ><span>{{ item.applyTime | formatTime }}</span>
            </div>
            <div class="arrow">
              <div :style="{ color: item.statusColor || '#FF5555' }">{{ item.statusMsg }}</div>
              <z-icon name="arrow" size="13px" :color="item.statusColor || '#FF5555'" />
            </div>
          </div>
          <div class="product-card-content">
            <div class="product-card-content-image">
              <z-image fit="cover" class="cover-image" :src="item.pic" />
            </div>
            <div class="product-card-content-info">
              <div class="product-card-content-info-title">{{ item.title }}</div>
              <div class="product-card-content-info-price">
                <span>售价：</span>{{ item.compensateMoney }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="empty"  v-if="!loading && compensationList.length === 0">
      <z-icon name="passed" size="1.06rem" color="#ff5555"/>
      <span class="passtext">暂无欺诈赔付申请记录</span>
    </div> -->
      <z-stance
        v-if="!loading && compensationList.length === 0"
        :show-btn="false"
        type="general"
        :show-info="false"
        descText="暂无欺诈赔付申请记录"
      />
    </section>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon, Image, Stance } from '@zz-common/zz-ui'
import { getPayMoneyHistopry } from '../../../api/resourceApi'
import setPicSize from '@zz-app/setPicSize'

export default {
  name: 'HistoryComp',
  data() {
    return {
      receiveList: [],
      compensationList: [],
      error: false,
      loading: false,
      refreshing: false,
      endTime: '',
      startTime: ''
    }
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY-MM-DD') : ''
    }
  },
  components: {
    zIcon: Icon,
    zImage: Image,
    zStance: Stance
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 600, 600)
    },
    async getHistory() {
      this.loading = true
      const res = await getPayMoneyHistopry()
      const { receiveList = [], compensationList = [] } = res
      this.loading = false
      this.receiveList = receiveList
      this.compensationList = compensationList
      receiveList.forEach((item) => {
        const { status, startTime, endTime } = item
        if (+status === 0) {
          this.startTime = startTime
          this.endTime = endTime
        }
      })
    },
    toReceive(_id) {
      // setTimeout(() => {
      //   native.skipToUrl({
      //     targetUrl: `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyReceive&id=${id}`
      //   });
      // }, 300);
    },
    toDetial(orderId) {
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDetial&orderId=${orderId}`
        })
      }, 300)
    },
    onRefresh() {
      this.refreshing = false
      this.getHistory()
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转'
    })
    this.getHistory()
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
